import Axios from 'axios'
import Share from './../share'
import { saveAs } from "file-saver";

const multipartConfig = {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}

function queryUrl(url, params) {
    var query = []
    for (var key in params) {
        if (params[key] == null)
            continue

        if (params[key] instanceof Date)
        {
            let date = params[key].getFullYear() + "-" + (params[key].getMonth() + 1) + "-" + params[key].getDate() + " " + params[key].getHours() + ":" + params[key].getMinutes() + ":" + params[key].getSeconds();
            query.push(key + '=' +  encodeURIComponent(date))
        }else{
            query.push(key + '=' + encodeURIComponent(params[key]))
        }
    }
    if (query.length == 0) {
        return url
    }
    return url + '?' + query.join('&')
}

function handlePromise(prom, loader, res, rej) {
    prom.then(resp => {
        if (loader) {
            Share.hideLoader()
        }
        if (resp.status === 200) {
            res(resp.data)
            return
        }
        if (resp.status === 204) {
            Share.showSnack('There is no data available.', 'warning')
            return
        }
        rej(resp.data, resp.status)
    })
    .catch(err => {
        if (loader) {
            Share.hideLoader()
        }
        if (err.response == null) {
            Share.showSnack('Looks like your network is down. Try again', 'error')
            return
        }
        
        // Model validation has failed on the server
        // Show validation error popup with messages 
        if (err.response.status === 400) {
            Share.showValidationError(err.response.data);
            return;
        }
        
        if (err.response.status === 401) {
            // Not logged in redirect
            window.location = '/'
            return
        }
        
        if (err.response.status === 403) {
            // Not authroized redirect
            window.location = '/auth/logout'
            return
        }
        // Let caller handle 404's.
        // 404 is set as API Failed with message
        if (err.response.status !== 404) {
            Share.showError()
        }
        rej(err.response.data, err.response.status)
    })
}

function post(url, data, loader = true, config = undefined) {
    if (loader) {
        Share.showLoader()
    }
    return new Promise((res, rej) => {
        handlePromise(Axios.post(url, data, config), loader, res, rej)
    })
}


function postForm(url, data, loader = true) {
    if (loader) {
        Share.showLoader()
    }
    
    var formData = new FormData();
    for (var k in data) {
        var v = data[k]
        
        if (Array.isArray(v) && v[0] instanceof File) {
            for (var file of v) {
                formData.append(k, file)
            }
            continue
        }

        if (v instanceof Date)
        {
            formData.append(k,  v.getFullYear() + "-" + (v.getMonth() + 1) + "-" + v.getDate() + " " + v.getHours() + ":" + v.getMinutes() + ":" + v.getSeconds())
            continue
        }

        if (v != undefined && v != null) {
            formData.append(k,  v)
        }
    }
    
    return new Promise((res, rej) => {
        handlePromise(Axios.post(url, formData, multipartConfig), loader, res, rej)
    })
}


function get(url, data, loader = true) {
    if (loader) {
        Share.showLoader()
    }
    return new Promise((res, rej) => {
        handlePromise(Axios.get(queryUrl(url, data)), loader, res, rej)
    })
}

function download(url, parms, name = null) {
    Share.showSnack("Your download will start shortly")
    window.location = queryUrl(url, parms)
}

export default {
    post,
    get,
    postForm,
    queryUrl,
    download
}
